/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ProfessionalServicesAgreement } from '../models/ProfessionalServicesAgreement';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ProvidersService {

    /**
     * @returns any No response body
     * @throws ApiError
     */
    public static providersContractRetrieve({
        id,
        xTz,
    }: {
        /**
         * A UUID string identifying this provider.
         */
        id: string,
        /**
         * The timezone of the user making the request
         */
        xTz: string,
    }): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/providers/{id}/contract/',
            path: {
                'id': id,
            },
            headers: {
                'x-tz': xTz,
            },
        });
    }

    /**
     * @returns ProfessionalServicesAgreement
     * @throws ApiError
     */
    public static providersContractCreate({
        id,
        xTz,
        requestBody,
    }: {
        /**
         * A UUID string identifying this provider.
         */
        id: string,
        /**
         * The timezone of the user making the request
         */
        xTz: string,
        requestBody: ProfessionalServicesAgreement,
    }): CancelablePromise<ProfessionalServicesAgreement> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/providers/{id}/contract/',
            path: {
                'id': id,
            },
            headers: {
                'x-tz': xTz,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
